import { makeStyles } from "tss-react/mui"
import { blueGrey } from "@mui/material/colors"

export const useStyles = makeStyles()(({ spacing, breakpoints }) => ({
  sectionLessons: {
    border: `1px solid ${blueGrey[100]}`,
    borderRadius: "3px !important",
    boxShadow: "none",
    marginBottom: spacing(1),

    "&.Mui-expanded:last-of-type": {
      marginBottom: spacing(2)
    },
    "&:focus": {
      border: `1px solid ${blueGrey[100]}`,
      boxShadow: "none !important",
      outlineColor: "transparent"
    },
    "&:before": {
      display: "none"
    },

    "&.Mui-disabled": {
      backgroundColor: "transparent"
    },

    ".MuiAccordionSummary-root": {
      minHeight: "31px",

      "&:focus": {
        border: "none",
        boxShadow: "none !important",
        outlineColor: "transparent"
      },

      "&.Mui-disabled": {
        opacity: 1
      },

      "& > .MuiAccordionSummary-content": {
        margin: spacing(2, 0)
      },

      "& > .MuiAccordionSummary-expandIconWrapper": {
        transform: "rotate(0deg)"
      }
    },

    "& > .MuiCollapse-root .MuiCollapse-wrapper": {
      paddingLeft: spacing(4),
      paddingBottom: spacing(2)
    }
  },
  accordionContent: {
    paddingLeft: 0
  },
  listContainer: {
    display: "flex",
    paddingLeft: spacing(4),
    overflowX: "auto",
    flexFlow: "column wrap",
    gap: "0 30px",
    maxHeight: 230,
    [breakpoints.down("md")]: {
      flexFlow: "column",
      overflowY: "auto"
    }
  },
  listItem: {
    width: "auto",
    padding: 0,
    display: "list-item",
    listStyleType: "disc",
    "&::marker": {
      fontSize: "0.6rem"
    }
  },
  item: {
    fontWeight: "normal"
  }
}))
